import { useCallback } from "react";

import useTypedContext from "hooks/useTypedContext";
import { Action, Context } from "types/generated";
import { AccessResult, NO_ACCESS_MESSAGE, hasAtLeastOneRequiredAction } from "utils/access";
import { AccountContext } from "views/AccountWrapper";

const UPDATE_CONTEXT_ACCESS_TYPES = [Action.SpaceAdmin, Action.ContextUpdate];

const useCanUpdateContext = (): ((context: Context) => AccessResult) => {
  const { viewer } = useTypedContext(AccountContext);

  return useCallback(
    (context: Context) => {
      if (context.plugin?.id) {
        return {
          result: false,
          message: `This context is managed by the plugin "${context.plugin.name}" and can't be edited manually.`,
        };
      }

      if (viewer.admin) {
        return { result: true };
      }

      const spaceId = context.space || context.spaceDetails.id;

      const hasAccess = hasAtLeastOneRequiredAction(UPDATE_CONTEXT_ACCESS_TYPES, viewer, spaceId);

      if (hasAccess) {
        return { result: true };
      }

      return { result: false, message: NO_ACCESS_MESSAGE };
    },
    [viewer]
  );
};

export default useCanUpdateContext;
